var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_4691)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13.4385C26 20.6182 20.1797 26.4385 13 26.4385C5.8203 26.4385 0 20.6182 0 13.4385C0 6.25878 5.8203 0.438477 13 0.438477C20.1797 0.438477 26 6.25878 26 13.4385ZM13.4659 10.0356C12.2014 10.5616 9.67432 11.6501 5.88455 13.3012C5.26915 13.546 4.94678 13.7854 4.91743 14.0195C4.86783 14.4151 5.36327 14.5709 6.03793 14.783C6.1297 14.8119 6.22478 14.8418 6.32227 14.8735C6.98602 15.0892 7.8789 15.3417 8.34306 15.3517C8.76411 15.3608 9.23404 15.1872 9.75286 14.8309C13.2938 12.4407 15.1216 11.2326 15.2363 11.2066C15.3173 11.1882 15.4295 11.1651 15.5055 11.2326C15.5815 11.3002 15.574 11.4282 15.566 11.4625C15.5169 11.6717 13.5721 13.4797 12.5657 14.4154C12.252 14.7071 12.0294 14.914 11.9839 14.9612C11.882 15.0671 11.7781 15.1672 11.6783 15.2635C11.0617 15.8579 10.5992 16.3037 11.7039 17.0317C12.2348 17.3815 12.6596 17.6708 13.0834 17.9594C13.5462 18.2746 14.0078 18.5889 14.6051 18.9804C14.7573 19.0802 14.9026 19.1838 15.0441 19.2847C15.5827 19.6687 16.0666 20.0137 16.6645 19.9587C17.0118 19.9267 17.3707 19.6001 17.5529 18.6259C17.9836 16.3235 18.8301 11.3351 19.0257 9.27953C19.0429 9.09943 19.0213 8.86895 19.004 8.76777C18.9867 8.66659 18.9505 8.52243 18.819 8.41571C18.6632 8.28933 18.4228 8.26267 18.3152 8.26457C17.8263 8.27318 17.0761 8.53403 13.4659 10.0356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_4691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.438477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2c107e755ae1499cf0ea793cef177664.svg";
export { ForwardRef as ReactComponent };